export const coreWalletUnmatchedPaymentStatusForSelection = [
	'Created', 'Resolved', 'Cancelled', 'Unresolvable', 'Ignored'
].map(status => {
	return {
		id: status,
		name: status
	}
});
